import React from "react";
import "../css/ContactUsModalView.css";

const ContactUsModalView = ({ isOpen, onClose, children }) => {
	if (!isOpen) return null;

	return (
		<div className="modal-backdrop" onClick={onClose}>
			<div
				className="modal-content"
				onClick={(e) => e.stopPropagation()} // prevent close on content click
			>
				<button className="modal-close" onClick={onClose}>
					×
				</button>
				{children}
			</div>
		</div>
	);
};

export default ContactUsModalView;
